
/**
 * Este objeto define as tabelas dinâmicas e suas respectivas colunas utilizadas no Offline (SQLite).
 * Ele é usado pela classe DynamicRepository para criar e manipular tabelas de forma dinâmica.
 * Com base nessas definições, as tabelas são criadas e gerenciadas dinamicamente.
 */
export const OfflineTables = [
  {
    name: 'USER_LOCATION',
    columns: ['LATITUDE', 'LONGITUDE']
  },
  {
    name: 'GPE_BANCOHORAS',
    columns: ['NRVINCULOM', 'NMVINCULOM', 'SALDO_FOLGAR_ACR_PER_BHR_NORM', 'SALDO_FOLGAR_PER_BHR_NORM']
  },
  {
    name: 'GPE_ATRASOS',
    columns: ['NRVINCULOM', 'NMVINCULOM', 'ATRASOS_DIURNOS']
  },
  {
    name: 'GPE_FALTAS',
    columns: ['NRVINCULOM', 'NMVINCULOM', 'FALTAS_HORAS', 'QTD_FALTAS']
  },
  {
    name: 'GPE_HORASEXTRAS',
    columns: ['NRVINCULOM', 'NMVINCULOM', 'EX_DIA_NORMAL_SEG']
  },
  {
    name: 'GPE_ATESTADOS',
    columns: ['NRVINCULOM', 'NMVINCULOM', 'NMESTRUTLEGAL', 'TOTAL_ATESTADOS']
  },
  {
    name: 'GPE_FERIAS',
    columns: ['NRVINCULOM', 'NMVINCULOM', 'DTFIMAQUISICAO', 'DIAS_GOZO', 'DATA_LIMITE', 'IDCONTROLFERIAS']
  },
  {
    name: 'GPE_CONTRATOS',
    columns: ['NRVINCULOM', 'NMVINCULOM', 'DTADMISSAOVINC', 'PRIMEIRA_PRORROGACAO', 'SEGUNDA_PRORROGACAO', 'DIAS_CONTRATO_VENCER']
  },
  {
    name: 'GPE_LICMATERNIDADE',
    columns: ['NRVINCULOM', 'NMVINCULOM', 'NMESTRUTURAH', 'DATA_FINAL']
  },
  {
    name: 'GPE_AFASTAMENTOS',
    columns: ['NRVINCULOM', 'NMVINCULOM', 'NMSITUFUNCH', 'DATA_INICIO', 'DATA_TERMINO', 'DIAS_AFASTAMENTO']
  },
  {
    name: 'GPE_ULTIMASFERIAS',
    columns: ['NRVINCULOM', 'NMVINCULOM', 'DTINIGOZOFERIAS', 'DTFIMGOZOFERIAS', 'TOTAL_GOZO', 'DIAS_RESTANTE_GOZO', 'IDCONTROLFERIAS', 'VINC_EM_GOZO']
  },
  {
    name: 'GPE_AUSENCIAREGISTRO',
    columns: ['NRVINCULOM', 'NMVINCULOM', 'ULTIMA_MARCACAO', 'NMESTRUTGEREN']
  },
  {
    name: 'GPE_SOLICITACAO',
    columns: ['NRVINCULOM', 'NMVINCULOM', 'NRSOLICITACAO', 'DTSOLICITACAO', 'NMTIPOSOLICITACAO', 'DSOBSSOLICITACAOABREV', 'DSAPROVACAOSEC']
  },
  {
    name: 'GPE_ADCNOTURNO',
    columns: ['NRVINVULOM', 'HRADICIONALNOTURNO']
  },
  {
    name: 'GPE_INDICAACIDENTE',
    columns: ['QTD_ACIDENTES']
  },
  {
    name: 'GPE_INDICAEPI',
    columns: ['QTD_EPIS']
  },
  {
    name: 'GPE_INDICAREUNIAO',
    columns: ['TOTAL', 'DTDATA']
  },
  {
    name: 'GPE_INDICAAFASTAMENTO',
    columns: ['QTD_AFASTAMENTOS']
  },
];

/**
 * Este objeto mapeia os nomes das tabelas para facilitar o acesso global.
 */
export const OfflineTablesName = {
  USER_LOCATION: 'USER_LOCATION',
  GPE_VINCULOM: 'GPE_VINCULOM',
};